import React from "react";
import {components} from "react-select";
import DropdownIndicatorIcon from "./DropdownIndicatorIcon";

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <DropdownIndicatorIcon status={props.selectProps.menuIsOpen} />
        </components.DropdownIndicator>
    );
};

export default DropdownIndicator;